import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

import _ from "lodash";

@Injectable()
export class DocrenService {
  constructor(private http: HttpClient) {}

  public findEplusFileById(eplusFileId: number): Observable<any> {
    return this.http.get<any[]>(
      environment.apiHost + "/eplusfile/" + eplusFileId
    );
  }

  public listEplusFileByClienteId(clienteId: number): Observable<any[]> {
    return this.http.get<any[]>(
      environment.apiHost + "/eplusfile/list/cliente/" + clienteId
    );
  }

  public listCategoriesByClienteId(clienteId: number): Observable<any[]> {
    return this.http.get<any[]>(
      environment.apiHost + "/eplusfile/categoria/list/cliente/" + clienteId
    );
  }

  public listSubCategoriesByCategoryId(categoryId: number): Observable<any[]> {
    return this.http.get<any[]>(
      environment.apiHost +
        "/eplusfile/subcategoria/list/categoria/" +
        categoryId
    );
  }

  public download(userId: number, fileId: number): Observable<any> {
    return Observable.fromPromise(
      new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open(
          "GET",
          environment.apiHost +
            "/eplusfile/download/s3/usuario/" +
            userId +
            "/file/" +
            fileId,
          true
        );
        xhr.responseType = "blob";
        xhr.onload = function (e) {
          if (xhr.status == 200) resolve(xhr.response);
        };
        xhr.send();
      })
    );
  }

  public getAvailableFilesByTeams(
    files: any,
    myTeams: any,
    isManager: boolean
  ): any {
    return _.reduce(
      files,
      (availables, item) => {
        item.information = JSON.parse(item.information);

        if (
          isManager ||
          item.information.publico ||
          this.isAvailableFile(myTeams, item.information.teams)
        )
          availables.push(item);

        return availables;
      },
      []
    );
  }

  public formatNodes(nodes: any, isSub: boolean): any[] {
    return nodes.map((item: any) => ({
      title: item.descricao,
      id: item.id,
      sub: [],
      isSub: !!isSub,
    }));
  }

  public isAvailableFile(myTeams: any, fileTeams: any): any {
    return _.some(myTeams, (myTeam) =>
      _.some(fileTeams, (fileTeamId) => fileTeamId == myTeam.id)
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/docren-service.ts